
<toggle-token-group
  ref="toggleTokenGroup"
  v-model="qualifications"
  :maxColumns="2"
  :tokens="tokens"
  legend="Do you have any training or certifications?"
  @input="updateTokenState"
/>
